
const headers = [
    {
      label: 'ชื่อผู้ใช้งาน',
      field: 'fullName'
    },
    {
      label: 'หมายเลขบัตรประชาชน',
      field: 'identityId'
    },
    {
      label: 'จัดการ',
      field: 'action'
    },
  ]

  export default headers